import { $el, isNotThemeStore } from 'src/scripts/utils/utils'
import { BaseComponent } from '../../components/base-component'

const scrollOptions = (jump: boolean): object => ({
  behavior: jump ? 'auto' : 'smooth',
  block: 'nearest',
})

export class ProductMedia extends BaseComponent {
  mountComponent(): void {
    this.setReady()
  }

  updateFirstMediaByVariant(imageId: string, jump = false): void {
    if (isNotThemeStore()) {
      if (imageId) {
        const media = $el(`[data-media-id="${imageId}"]`, this)

        const element = media ?? this

        element.scrollIntoView(scrollOptions(jump))
      }
    }
  }

  setReady(): void {
    this.setAttribute('ready', '')
  }
}
